import './example';
import logo from './loader.svg';

import {readFileSync} from 'fs'

function loadScript(url) {
  return new Promise((resolve) => {
    let head = document.getElementsByTagName('head')[0];
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.onload = () => { resolve(); };

    // Fire the loading
    head.appendChild(script);
  });
}

const css = readFileSync(__dirname + '/metabar.css', 'utf-8')
const meta = JSON.parse(readFileSync(__dirname + '/meta.json', 'utf-8'))

let metabar = `<div class="metabar">
        <div class="metabar-inner">
            <div class="metabar__block metabar__block--left"><a href="/examples/" class="metabar__link">&leftarrow; More examples</a></div>
            <div>
                <a href="https://infiniteajaxscroll.com" title="Infinite Ajax Scroll" class="logo"><img src="${logo}"></a>
            </div>
            <div class="metabar__block metabar__block--right"><a href="${meta.codesandbox_url}" class="btn" target="_blank">Edit on <span class="codesandbox" title="CodeSandbox">CodeSandbox</span></a></div>
        </div>
    </div>
    <style>${css}</style>`;

// let style = parseInt(window.getComputedStyle(document.body).paddingTop);
// document.body.style.paddingTop = (style + 65) + 'px';

document.body.insertAdjacentHTML('afterbegin', metabar);

// google analytics

loadScript('https://www.googletagmanager.com/gtag/js?id=UA-18000252-3')
    .then(() => {
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());

      gtag('config', 'UA-18000252-3');
    }
);

// drift

// !function() {
//   var t;
//   if (t = window.driftt = window.drift = window.driftt || [], !t.init) return t.invoked ? void (window.console && console.error && console.error("Drift snippet included twice.")) : (t.invoked = !0,
//       t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on" ],
//       t.factory = function(e) {
//         return function() {
//           var n;
//           return n = Array.prototype.slice.call(arguments), n.unshift(e), t.push(n), t;
//         };
//       }, t.methods.forEach(function(e) {
//     t[e] = t.factory(e);
//   }), t.load = function(t) {
//     var e, n, o, i;
//     e = 3e5, i = Math.ceil(new Date() / e) * e, o = document.createElement("script"),
//         o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + i + "/" + t + ".js",
//         n = document.getElementsByTagName("script")[0], n.parentNode.insertBefore(o, n);
//   });
// }();
// drift.SNIPPET_VERSION = '0.3.1';
// drift.load('6xfngbrkf5ky');

// hotjar

(function(h,o,t,j,a,r){
  h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
  h._hjSettings={hjid:1472346,hjsv:6};
  a=o.getElementsByTagName('head')[0];
  r=o.createElement('script');r.async=1;
  r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
  a.appendChild(r);
})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
